import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import clsx from "clsx";

export function RadioGroupIndicator({ className, style, ...rest }: RadixRadioGroup.RadioGroupIndicatorProps) {
  return (
    <RadixRadioGroup.Indicator
      {...rest}
      className={clsx(
        "flex",
        "grow",
        "items-center",
        "justify-center",
        "relative",
        "rounded-full",
        "-m-px",
        "bg-platform-600",
        "after:content-['']",
        "after:bg-white",
        "after:block",
        "after:w-[33%]",
        "after:h-[33%]",
        "after:rounded-full",
        className
      )}
      style={style}
    />
  );
}
